<div class="h-screen w-full py-6">
  <div
    class="flex flex-col p-10 items-center justify-start h-full overflow-auto"
    >
    <div
      class="tablet-min:w-1/2 tablet-max:w-full tablet-max:dark-main-bg-plain"
      >
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <a
          [routerLink]="['/login']"
          class="text-md mb-6 flex flex-row items-center gap-2 text-orange-400"
          >
          <mat-icon fontIcon="arrow_back"></mat-icon>Back
        </a>
        <h1 class="text-4xl mb-12">Sign Up</h1>
        <div
          formGroupName="data"
          class="outline outline-2 p-12 tablet-max:p-6 rounded-md"
          >
          <div
            class="flex flex-col items-start justify-start h-full w-full gap-3"
            >
            <span class="text-lg">General</span>
            <mat-form-field class="w-full">
              <mat-label>First Name</mat-label>
              <input
                type="text"
                matInput
                formControlName="first_name"
                placeholder="John"
                />
                @if (
                  registerForm.get('data.first_name').hasError('required') &&
                  registerForm.get('data.first_name').dirty
                  ) {
                  <mat-error
                    >
                    Please enter a valid name
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>Last Name</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="last_name"
                  placeholder="Doe"
                  />
                  @if (
                    registerForm.get('data.last_name').hasError('required') &&
                    registerForm.get('data.last_name').dirty
                    ) {
                    <mat-error
                      >
                      Please enter a valid name
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field class="w-full">
                  <mat-label>Company Name</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="company_name"
                    placeholder="ACME Inc."
                    />
                    @if (
                      registerForm.get('data.company_name').hasError('required') &&
                      registerForm.get('data.company_name').dirty
                      ) {
                      <mat-error
                        >
                        Company Name is required
                      </mat-error>
                    }
                  </mat-form-field>

                  <div class="py-2 mt-3">
                    <span class="text-lg">Contact Info</span>
                  </div>
                  <mat-form-field class="w-full">
                    <mat-label>Email</mat-label>
                    <input
                      type="email"
                      matInput
                      formControlName="email"
                      placeholder="Ex. name@example.com"
                      />
                      @if (
                        ((registerForm.get('data.email').hasError('required') ||
                        registerForm.get('data.email').hasError('email')) &&
                        registerForm.get('data.email').dirty) ||
                        registerForm.get('data.email').touched
                        ) {
                        <mat-error
                          >
                          Please enter a valid email address
                        </mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field class="w-full">
                      <mat-label>Cell Phone</mat-label>
                      <input
                        type="text"
                        matInput
                        formControlName="cell_phone"
                        placeholder="+1-XXX-XXXX"
                        />
                        @if (
                          ((registerForm.get('data.cell_phone').hasError('pattern') ||
                          registerForm
                          .get('data.cell_phone')
                          .hasError('maxLength')) &&
                          registerForm.get('data.cell_phone').dirty) ||
                          registerForm.get('data.cell_phone').touched
                          ) {
                          <mat-error
                            >
                            Please enter a valid cell phone number
                          </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field class="w-full">
                        <mat-label>Work Phone</mat-label>
                        <input
                          type="text"
                          matInput
                          formControlName="work_phone"
                          placeholder="+1-XXX-XXXX"
                          />
                          @if (
                            (registerForm.get('data.work_phone').hasError('pattern') ||
                            registerForm
                            .get('data.work_phone')
                            .hasError('maxLength')) &&
                            registerForm.get('data.work_phone').dirty
                            ) {
                            <mat-error
                              >
                              Please enter a valid work_phone phone number
                            </mat-error>
                          }
                        </mat-form-field>

                        <div class="py-2 mt-3">
                          <span class="text-lg">Address</span>
                        </div>
                        <mat-form-field class="w-full">
                          <mat-label>Address Line</mat-label>
                          <input
                            type="text"
                            matInput
                            formControlName="address_mail"
                            placeholder="Address"
                            />
                            @if (
                              (registerForm.get('data.address_mail').hasError('required') &&
                              registerForm.get('data.address_mail').dirty) ||
                              registerForm.get('data.address_mail').touched
                              ) {
                              <mat-error
                                >
                                Please enter a valid mailing address
                              </mat-error>
                            }
                          </mat-form-field>
                          <mat-form-field class="w-full">
                            <mat-label>Address 2</mat-label>
                            <input
                              type="text"
                              matInput
                              formControlName="address_mail_line2"
                              placeholder="Address"
                              />
                            </mat-form-field>
                            <mat-form-field class="w-full">
                              <mat-label>City</mat-label>
                              <input
                                type="text"
                                matInput
                                formControlName="address_mail_city"
                                placeholder="City"
                                />
                                @if (
                                  (registerForm
                                  .get('data.address_mail_city')
                                  .hasError('required') &&
                                  registerForm.get('data.address_mail_city').dirty) ||
                                  registerForm.get('data.address_mail_city').touched
                                  ) {
                                  <mat-error
                                    >
                                    Please enter a valid city
                                  </mat-error>
                                }
                              </mat-form-field>
                              <mat-form-field class="w-full">
                                <mat-label>Province</mat-label>
                                <input
                                  type="text"
                                  matInput
                                  formControlName="address_mail_province"
                                  placeholder="Address"
                                  />
                                  @if (
                                    (registerForm
                                    .get('data.address_mail_province')
                                    .hasError('required') &&
                                    registerForm.get('data.address_mail_province').dirty) ||
                                    registerForm.get('data.address_mail_province').touched
                                    ) {
                                    <mat-error
                                      >
                                      Please enter a valid Province
                                    </mat-error>
                                  }
                                </mat-form-field>
                                <mat-form-field class="w-full">
                                  <mat-label>Country</mat-label>
                                  <input
                                    type="text"
                                    matInput
                                    formControlName="address_mail_country"
                                    placeholder="Country"
                                    />
                                    @if (
                                      (registerForm
                                      .get('data.address_mail_country')
                                      .hasError('required') &&
                                      registerForm.get('data.address_mail_country').dirty) ||
                                      registerForm.get('data.address_mail_country').touched
                                      ) {
                                      <mat-error
                                        >
                                        Please enter a valid Country
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                  <mat-form-field class="w-full">
                                    <mat-label>Postal Code</mat-label>
                                    <input
                                      type="text"
                                      matInput
                                      formControlName="address_mail_postal_code"
                                      placeholder="Postal Code"
                                      />
                                      @if (
                                        (registerForm
                                        .get('data.address_mail_postal_code')
                                        .hasError('required') &&
                                        registerForm.get('data.address_mail_postal_code').dirty) ||
                                        registerForm.get('data.address_mail_postal_code').touched
                                        ) {
                                        <mat-error
                                          >
                                          Please enter a valid postal code or zip code
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                    <span class="text-lg py-4">Password</span>
                                    <mat-form-field class="w-full">
                                      <mat-label>Password</mat-label>
                                      <input
                                        type="password"
                                        matInput
                                        formControlName="password"
                                        placeholder="password"
                                        />
                                        @if (
                                          ((registerForm.get('data.password').hasError('required') ||
                                          registerForm.get('data.password').hasError('pattern')) &&
                                          registerForm.get('data.password').dirty) ||
                                          registerForm.get('data.password').touched
                                          ) {
                                          <mat-error
                                            >
                                            Please enter a valid Password
                                          </mat-error>
                                        }
                                      </mat-form-field>
                                      <div>
                                        <mat-form-field class="w-full">
                                          <mat-label>Confirm Password</mat-label>
                                          <input
                                            type="password"
                                            matInput
                                            [formControl]="registerForm.get('confirmPassword')"
                                            [errorStateMatcher]="crossFieldErrorMatcher"
                                            placeholder="confirm password"
                                            />
                                            @if (
                                              registerForm.get('confirmPassword').hasError('required') &&
                                              (registerForm.get('confirmPassword').dirty ||
                                              registerForm.get('confirmPassword').touched)
                                              ) {
                                              <mat-error
                                                >
                                                Please re-enter your password
                                              </mat-error>
                                            }
                                            @if (
                                              registerForm.hasError('passwordMismatch') &&
                                              (registerForm.get('confirmPassword').dirty ||
                                              registerForm.get('confirmPassword').touched)
                                              ) {
                                              <mat-error
                                                class="input-error"
                                                >
                                                Password does not match
                                              </mat-error>
                                            }
                                          </mat-form-field>
                                          <p class="text-sm px-2 text-gray-400">
                                            Password must be at least 8 characters long and include at least
                                            one uppercase letter, one lowercase letter, one number, and one
                                            special character (e.g., &#64;, #, $, !, %, *, ?, &)
                                          </p>
                                        </div>
                                        <button
                                          type="submit"
                                          class="text-md p-3 rounded-xl mt-6 w-full"
              [class]="
                registerForm.valid
                  ? 'bg-custom-orange text-white'
                  : 'outline outline-2 text-gray'
              "
                                          [disabled]="!registerForm.valid"
                                          >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
